import React, { useEffect, useState } from 'react'
import { Card, Col, Form,Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { faBullhorn, faFilter, faPlus, faSave } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import AccordionComponent from '@component/Accordion'
import BreadcrumbComponent from '@component/Breadcrumb'
import ButtonComponent from '@component/Form/Button'
import DataTableComponent from '@component/Datatable'
import DateComponent from '@component/Form/Date'
import DropdownComponent from '@component/Dropdown'
import InputComponent from '@component/Form/Input'
import SelectComponent from '@component/Form/Select'
import TextareaComponent from '@component/Form/Textarea'

import { AclService } from '@service/acl'


const breadcrumbItems = [
    { title: 'Home', url: '/dashboard' },
    { title: 'Contratos' }
]


export default function ManagementContracts() {

    const navigate = useNavigate();

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register,
        setValue,
        reset
    } = useForm({mode:'onChange'})


    const onSubmit = async (data, e) => {
        e.preventDefault();
    }

    const dropdown = (manifestation_id) => {
        let content = [
            {titulo: 'Visualizar detalhes', parametro: {url: `/management/contracts/details/${manifestation_id}`}},
        ];

        return <DropdownComponent function={dropdownAction} content={content} />
    }


    const dropdownAction = (parametro) => {
        if (!parametro.hasOwnProperty('onclick')) {
            navigate(parametro.url)
        } else eval(parametro.onclick)(parametro.item)
    }

    // DATA	CONTRATOS	HISTORICO	DISCRIÇÃO DO ORGÇAO	N DO EMPENHO	VALOR DO EMPENHO	 VALOR LIQUIDADIO


    const columns = [
        {
            cell: (row) => (
                '-'
            ),
            center: true,
            name: 'Data',
            selector: 'date',
            sortable: true,
            width: '10%'
        },
        {
            cell: (row) => (
                '-'
            ),
            center: true,
            name: 'Contrato',
            selector: 'contract',
            sortable: true,
            width: '12%'
        },
        {
            cell: (row) => (
                '-'
            ),
            center: true,
            name: 'Título',
            selector: 'title',
            sortable: true,
            width: '20%'
        },
        {
            cell: (row) => (
                '-'
            ),
            center: true,
            name: 'Valor',
            selector: 'value',
            sortable: true,
            width: '16%'
        },
        {
            cell: (row) => {
                return (row.status) ? (
                    <span className='badge bg-success'>Liberado</span>
                ) : (<span className='badge bg-danger'>Bloqueado</span>)
            },
            center: true,
            name: 'Situação',
            selector: 'status',
            sortable: true,
            width: '10%'
        },
        {
            cell: (row) => ( dropdown(row.id) ),
            center: true,
            name: 'Ações',
            sortable: false,
            width: '10%'
        }
    ]
    

    return (

        <>

            <div className='header' id='customer_form'>
                <h1 className='header-title'>Gerenciamento de Contratos</h1>

                <BreadcrumbComponent breadcrumb={breadcrumbItems} />
            </div>
          
            <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <AccordionComponent
                        data={[{
                            title: 'Adicionar contrato', 
                            icon: faPlus, 
                            body: (
                                <Form 
                                    autoComplete='off'
                                    noValidate
                                    onSubmit={handleSubmit(onSubmit)}>
                                
                                    <Row>
                                        <Col lg={2}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Contrato'
                                                name='contract'
                                                required={true}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={4}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Título'
                                                name='card'
                                                placeholder='Informe o título do contrato'
                                                required={true}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <DateComponent
                                                control={control}
                                                errors={errors}
                                                label='Data da Vencimento'
                                                name='date'
                                                register={register}
                                                required={true}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <InputComponent
                                                control={control}
                                                errors={errors}
                                                label='Valor do Contrato'
                                                name='value'
                                                required={true}
                                                type='text'
                                                register={register}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={12}>
                                            <TextareaComponent
                                                control={control}
                                                errors={errors}
                                                name='description'
                                                label='Descrição do objeto'
                                                placeholder='Informe o objeto do contrato'
                                                required={true}
                                                register={register}
                                                rows={2}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className='mb-3'>
                                        <Col lg={6}></Col>
    
                                        <Col lg={6} className='text-end'>
                                            <ButtonComponent
                                                variant='success'
                                                icon={faSave}
                                                id='btn-save'
                                                title='Gravar'
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                            )
                        }]}
                    />
                </Col>
            </Row>


            <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <h5 className="card-title">Contratos registrados</h5>
                        </Card.Header>
                        <Card.Body>
                            <DataTableComponent
                                columns={columns}
                                url={'/ombudsman-manifestations'}
                                title=''
                                pagination={true}
                                subHeader={true}
                                expandable={false}
                                expandableData=''
                                selectableRows={false}
                                selectableRowsNoSelectAll={false}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </>

    )
}
